import jQuery from "jquery";
window.jQuery = jQuery;
import("./vendor/jquery.placeholder");
import("./vendor/jquery.dropdown");
import("jquery-ui/ui/version");
import("jquery-ui/ui/unique-id");
import("jquery-ui/ui/keycode");
import("jquery-ui/ui/widget");
import("jquery-ui/ui/widgets/tabs");
import("jquery-ui/ui/widgets/datepicker");
import("jquery-ui/ui/i18n/datepicker-ja");
import { tablemill } from "./tablemill_metal";
import("./header");

jQuery(($) => {
  $.datepicker.setDefaults({
    dateFormat: "yy-mm-dd",
    showOn: "focus",
    autoSize: false,
    showAnim: "show",
    constrainInput: true,
    changeYear: true,
    changeMonth: true,
    firstDay: 1, // Monday is the first week day
    yearRange: `${tablemill.FIRST_DATA_DATE.getFullYear()}:${new Date().getFullYear()}`,
    minDate: tablemill.FIRST_DATA_DATE,
    maxDate: -1, // yesterday
    defaultDate: -1, // yesterday
  });

  const today = new Date();
  $(".enable_calendar").datepicker({
    yearRange: `${today.getFullYear() - 1}:+3`,
    minDate: new Date(
      today.getFullYear() - 1,
      today.getMonth(),
      today.getDate(),
    ),
    maxDate: null,
  });

  $("#goiken_form").submit((event: JQuery.SubmitEvent) => {
    const goiken_text_val = $("#goiken_text").val() as string;
    const goiken_length = goiken_text_val.length;

    if (!(0 < goiken_length && goiken_length < 10000)) {
      return false;
    }

    event.preventDefault();
    const form = $("#goiken_form");

    $.ajax(form.attr("action")!, {
      type: form.attr("method") as "GET" | "POST",
      data: form.serialize(),
      beforeSend: () => {
        $(".goiken_submit").prop("disabled", true);
        $("#goiken_text").hide();
        $(".goiken_processing.indicator").show();
      },
      success: () => {
        $(".goiken_processing").hide();
        $(".goiken_success").css("display", "table-cell");
      },
      error: () => {
        $(".goiken_processing").hide();
        $(".goiken_error").css("display", "table-cell");
      },
    });
  });
});
